var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');

// Job Area
module.exports = React.createClass({
	
	getInitialState : function(){
		return {
			top : 0
		}
	},
	
	componentDidMount : function(){
		this.setState({ 
			top : $(window).height() - 80,
			width : $(window).width()
		});	
	},
	
	// Render
  	render: function(){
  		
  		var style = { width : this.state.width+'px', top : this.state.top+'px' };
  		
   		return (
   			<div className="powered-by" style={style}>
   				
   				<div className="content">
	   				<a target="_blank" href="http://searchsoftware.nl?ref=apply">
	   					<img src="/assets/searchsoftware_logo.png" />
	   				</a>
	   				<div className="text">
	   					<label>Powered by</label> <a target="_blank" href="http://searchsoftware.nl?ref=job_board">Searchsoftware</a>
	   				</div>
					<div className="clear"></div>
				</div>
	  		</div>
	  	);
	}
});
